import React, { useContext } from "react";
import { t } from "i18next";
import { JointBillContext } from "@features/JointBillList/utils";
import { Checkbox } from "@components/inputs/Checkbox/Checkbox";
import { formatPrice } from "@utils/units";

interface IProviderBillTotalCellProps {
  amount: number;
  currency: string;
  isCheckboxChecked?: boolean;
  isCheckboxDisabled?: boolean;
  isCheckboxLoading?: boolean;
  onCheckboxClick?: () => void;
}

export const DonationBillTotalCell: React.FC<IProviderBillTotalCellProps> = ({
  amount,
  currency,
  isCheckboxChecked,
  isCheckboxDisabled,
  isCheckboxLoading,
  onCheckboxClick,
}) => {
  const { isSummaryMode } = useContext(JointBillContext);

  return (
    <div className="flex flex-col-reverse items-end gap-2 md:flex-row md:items-center md:gap-3.5">
      <span className="text-sm font-semibold leading-6 md:text-base">
        {formatPrice(amount, {
          currency: currency,
        })}
      </span>
      {!isSummaryMode && (
        <Checkbox
          checked={isCheckboxChecked}
          disabled={isCheckboxDisabled}
          onChange={onCheckboxClick}
          isLoading={isCheckboxLoading}
          aria-label={t("label.donationBillCheckbox")}
          wrapperClassName="!w-[unset] md:!w-full"
        />
      )}
    </div>
  );
};
